import { FC } from "react";
import { appointment_product } from "../../../../types/calendar";
import { Button } from "antd";
import {
  deleteIconSVG,
  editSVG,
  ProductSVG,
} from "../../../../assets/SVGs/SVGs";
import { useIntl } from "react-intl";
import { FaCircle } from "react-icons/fa6";
import { CiCircleCheck } from "react-icons/ci";
interface ProductProps {
  product: appointment_product;
  changeEditMode: (
    id: number,
    value: boolean,
    type: "service" | "package" | "product"
  ) => void;
  deleteProduct: (id: number) => void;
  handleChangeProductQty: (
    productId: number,
    type: "increase" | "decrease"
  ) => void;
  canEdit: boolean;
}

const Product: FC<ProductProps> = ({
  product,
  changeEditMode,
  deleteProduct,
  handleChangeProductQty,
  canEdit,
}) => {
  const intl = useIntl();
  return (
    <div>
      <div className="bg-[#EEF0FF] p-1 my-1 rounded text-sm">
        <div className="flex gap-2  justify-between rounded" key={product?.id}>
          <p className="flex gap-2 items-center">
            <span>{ProductSVG}</span>
            <span>{product?.name}</span>
          </p>

          <div className="flex gap-2">
            <div className="flex gap-2 items-center ">
              {product?.category?.name ? (
                <p className="flex gap-1 items-center ">
                  <FaCircle size={8} color="#A9AEF6" />

                  <span>{product?.category?.name} </span>
                </p>
              ) : null}
              <p className="flex gap-1 items-center ">
                <FaCircle size={8} color="#9999A7" />

                <span>{product?.retail_price}</span>
                <small className="text-[10px] self-center mt-2">
                  {intl.formatMessage({
                    id: "SARshort",
                  })}
                </small>
              </p>
            </div>
            <div className="flex gap-1 items-center">
              {product?.editable && canEdit ? (
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => {
                    handleChangeProductQty(product.id, "increase");
                  }}
                  className=""
                >
                  <span className="">+</span>
                </Button>
              ) : null}
              <p className="text-center bg-white rounded-lg p-2 px-3">
                {Number(product?.pivot?.quantity) || 1}
              </p>
              {product?.editable && canEdit ? (
                Number(product?.pivot?.quantity) > 1 ? (
                  <Button
                    type="default"
                    htmlType="button"
                    onClick={() => {
                      handleChangeProductQty(product.id, "decrease");
                    }}
                  >
                    -
                  </Button>
                ) : (
                  <Button
                    type="text"
                    htmlType="button"
                    onClick={() => {
                      deleteProduct(product?.id);
                    }}
                  >
                    {deleteIconSVG}
                  </Button>
                )
              ) : null}
            </div>
            {canEdit ? (
              <Button
                type="text"
                htmlType="button"
                onClick={() => {
                  changeEditMode(product?.id, !product?.editable, "product");
                }}
              >
                {!product?.editable ? editSVG : <CiCircleCheck size={20} />}
              </Button>
            ) : null}
            {product?.editable && canEdit ? (
              <Button
                type="text"
                htmlType="button"
                onClick={() => {
                  deleteProduct(product?.id);
                }}
              >
                {deleteIconSVG}
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
